<template>
	<span>
		<!-- <input type="text" class="tbl_int" :value="value" :placeholder="ph" :disabled="disabled" autocomplete="off" style="width:80px;" @input="updateValue" @keyup.enter="search()" /> -->
		<input type="text" class="tbl_int" :value="value" :placeholder="ph" :disabled="disabled" autocomplete="off" v-bind:style="'width:' + codeWidth + 'px;'" @input="updateValue" @keyup.enter="selectItemClass()" />
		<!-- <autocomplete ref="ac" :initialDisplay="keyword" :source="selectClasses" @nothingSelected="searchKeyword" @selected="selectClass" placeholder="Class Name, Keyword or Barcode"> </autocomplete> -->

		<button :disabled="disabled" @click="selectItemClass()">...</button>
		<!-- <span v-if="showName" class="int_type2"><input v-model="name" v-bind:style="'width:' + nameWidth + 'px;'" class="tbl_int sm_int" readonly @click="selectPartner()"/></span> -->
		<span v-if="showName" class="int_type2"><input :value="name" v-bind:style="'width:' + nameWidth + 'px;'" class="tbl_int sm_int" :disabled="disabled" readonly @click="selectItemClass()"/></span>

		<Modal @close="closeModal" v-if="showModal" :draggable="false" style="z-index:3000">
			<template slot="title">Select Item {{ headers.class }}</template>
			<template slot="body">
				<!-- <ItemClassPopup :initialKeyword="value" :code_only="false" @close="closeModal()" @ok="closeModalWithOK()" @set-item-class="setItemClass" /> -->
				<ItemClassPopup :initialKeyword="value" :code_only="false" @close="closeModal" @set-item-class="setItemClass" />
			</template>
		</Modal>
	</span>
	<!-- <select ref="dl" :class="className" v-bind:style="'width:' + width + 'px;'"></select> -->
</template>

<script>
import { inputSelectOnClick } from '@/utils/etc.js';
import { apiSelectItemClass } from '@/api/item/class.js';
import ItemClassPopup from '@/components/common/ItemClassPopup';
import Modal from '@/components/common/Modal';
export default {
	data: function() {
		return {
			//code: null,
			name: this.initialName,
			// dl: null,
			// desc: null,
			showModal: false,
		};
	},
	components: {
		ItemClassPopup,
		Modal,
	},
	props: {
		value: String,
		initialName: String,

		ph: String,
		showName: {
			type: Boolean,
			default: true,
		},
		codeWidth: {
			type: Number,
			default: 80,
		},
		nameWidth: {
			type: Number,
			default: 300,
		},
		disabled: {
			type: Boolean,
			default: false,
		},

		resetAfterPopup: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		headers: function() {
			return { class: this.$session.get('headerClass') };
		},
		user: function() {
			return this.$session.get('user');
		},
	},
	watch: {
		initialName: function(newVal) {
			//console.log(newVal);
			this.name = newVal;
		},
	},
	methods: {
		// selectClasses(input) {
		// 	var url = process.env.VUE_APP_API_URL + '/api/item/item_class/acClassList?company_id=' + this.user.company_id + '&keyword=' + input;
		// 	url += '&include_closed_yn=N';

		// 	//console.log(url);
		// 	return url;
		// 	//return process.env.VUE_APP_API_URL + '/api/item/item_class/acClassList?company_id=' + this.user.company_id + '&keyword=' + input;
		// },
		updateValue: function(event) {
			this.$emit('input', event.target.value);
		},
		selectItemClass() {
			this.showModal = true;
		},
		closeModal() {
			//this.$emit('input', null);
			if (this.resetAfterPopup) this.$emit('input', null);
			this.showModal = false;
		},
		closeModalWithOK() {
			// console.log('okkkk');
			// this.$emit('ok');
			// this.showModal = false;
		},
		setItemClass(itemClass) {
			//console.log(itemClass);
			// this.code = partner.code;
			this.name = itemClass.name;

			this.$emit('input', itemClass.code);

			this.$emit('set-item-class', itemClass);
			this.$emit('set-item-class2', itemClass);

			//this.$emit('input', null);
		},
		async search() {
			var keyword = this.value.trim();
			if (!keyword) return;

			//console.log('search....', '*' + keyword + '*');
			const { data } = await apiSelectItemClass({
				code: keyword,
			});
			// this.pensioners = data;
			// if (this.pensioners.length > 0 && this.selectedPsNo == null) {
			// 	this.selectRow(this.pensioners[0]);
			// }
			//console.log(data);
			//this.partners = data.partnerList;
			if (data.itemClass) {
				this.setItemClass(data.itemClass);
			} else {
				this.name = '';
				this.$emit('input', null);
				this.$toast.error('Item ' + this.headers.class + ' Code of "' + keyword + '" Not Found');
			}
		},
	},
	mounted() {
		inputSelectOnClick();
	},
	// data: function() {
	// 	return {
	// 		dl: null,
	// 	};
	// },
	// props: {
	// 	value: String,
	// 	itemClasses: Array,
	// 	width: {
	// 		type: Number,
	// 		default: 150,
	// 	},
	// 	className: String,
	// 	disabled: {
	// 		type: Boolean,
	// 		default: false,
	// 	},
	// },
	// watch: {
	// 	itemClasses: function(newVal) {
	// 		this.loadData(newVal);
	// 	},
	// 	value: function(newVal) {
	// 		if (!newVal) {
	// 			this.dl.unSelectOption();
	// 		} else {
	// 			this.dl.setComboValue(newVal);
	// 		}
	// 	},
	// 	disabled: function(newVal) {
	// 		this.dl.disable(newVal);
	// 	},
	// },
	// methods: {
	// 	loadData() {
	// 		var options = [];
	// 		for (var i = 0; i < this.itemClasses.length; i++) {
	// 			options.push({
	// 				value: this.itemClasses[i].code,
	// 				text: {
	// 					code: this.itemClasses[i].code,
	// 					name: this.itemClasses[i].name,
	// 					class_group_code: this.itemClasses[i].class_group_code,
	// 					dept_a_code: this.itemClasses[i].dept_a_code ? this.itemClasses[i].dept_a_code : '',
	// 					dept_b_code: this.itemClasses[i].dept_b_code ? this.itemClasses[i].dept_b_code : '',
	// 					category_code: this.itemClasses[i].category_code ? this.itemClasses[i].category_code : '',
	// 				},
	// 			});
	// 		}
	// 		this.dl.addOption(options);
	// 	},
	// 	getItemClass(value) {
	// 		for (var i = 0; i < this.itemClasses.length; i++) {
	// 			if (this.itemClasses[i].code == value) {
	// 				//console.log(this.itemClasses[i]);
	// 				return this.itemClasses[i];
	// 			}
	// 		}
	// 		return null;
	// 	},
	// },
	// mounted() {
	// 	var vm = this;
	// 	this.dl = new window.dhtmlXComboFromSelect(this.$refs.dl);
	// 	this.dl.setTemplate({
	// 		input: '#code#',
	// 		header: true,
	// 		columns: [
	// 			{ header: 'Code', width: 150, option: '#code#' },
	// 			{ header: 'Name', width: 350, option: '#name#' },
	// 			{ header: 'Class Group', width: 80, option: '#class_group_code#' },
	// 			{ header: 'Dept A', width: 55, option: '#dept_a_code#' },
	// 			{ header: 'Dept B', width: 55, option: '#dept_b_code#' },
	// 			{ header: 'Category', width: 65, option: '#category_code#' },
	// 		],
	// 	});
	// 	this.dl.disableAutocomplete();
	// 	this.dl.setFilterHandler(function(mask, option) {
	// 		var idx = option.text.name.toUpperCase().indexOf(mask.toUpperCase());
	// 		var idx2 = option.text.code.toUpperCase().indexOf(mask.toUpperCase());
	// 		return idx >= 0 || idx2 >= 0 ? true : false;
	// 	});
	// 	this.dl.enableFilteringMode(true);
	// 	this.dl.setFontSize('124x', '14px');
	// 	this.dl.attachEvent('onChange', function(value) {
	// 		vm.$emit('input', value);
	// 		vm.$emit('set-item-class', vm.getItemClass(value));
	// 	});
	// },
};
</script>

<style></style>
